const THREE = require("three");
class C278 {
  constructor() {
    this.enabled = true;
    this.needsSwap = true;
    this.clear = false;
    this.renderToScreen = false;
  }
  setSize() {}
  render() {
    console.error("THREE.Pass: .render() must be implemented in derived pass.");
  }
  dispose() {}
}
const v9345 = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
const v9346 = new THREE.BufferGeometry();
v9346.setAttribute("position", new THREE.Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));
v9346.setAttribute("uv", new THREE.Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));
class C279 {
  constructor(p11936) {
    this._mesh = new THREE.Mesh(v9346, p11936);
  }
  dispose() {
    this._mesh.geometry.dispose();
  }
  render(p11937) {
    p11937.render(this._mesh, v9345);
  }
  get material() {
    return this._mesh.material;
  }
  set material(p11938) {
    this._mesh.material = p11938;
  }
}
export class RenderPass extends C278 {
  constructor(p11939, p11940, p11941, p11942, p11943) {
    super();
    this.scene = p11939;
    this.camera = p11940;
    this.overrideMaterial = p11941;
    this.clearColor = p11942;
    this.clearAlpha = p11943 !== undefined ? p11943 : 0;
    this.clear = true;
    this.clearDepth = false;
    this.needsSwap = false;
    this._oldClearColor = new THREE.Color();
  }
  render(p11944, p11945, p11946) {
    const v9347 = p11944.autoClear;
    p11944.autoClear = false;
    let v9348;
    let v9349;
    if (this.overrideMaterial !== undefined) {
      v9349 = this.scene.overrideMaterial;
      this.scene.overrideMaterial = this.overrideMaterial;
    }
    if (this.clearColor) {
      p11944.getClearColor(this._oldClearColor);
      v9348 = p11944.getClearAlpha();
      p11944.setClearColor(this.clearColor, this.clearAlpha);
    }
    if (this.clearDepth) {
      p11944.clearDepth();
    }
    p11944.setRenderTarget(this.renderToScreen ? null : p11946);
    if (this.clear) {
      p11944.clear(p11944.autoClearColor, p11944.autoClearDepth, p11944.autoClearStencil);
    }
    p11944.render(this.scene, this.camera);
    if (this.clearColor) {
      p11944.setClearColor(this._oldClearColor, v9348);
    }
    if (this.overrideMaterial !== undefined) {
      this.scene.overrideMaterial = v9349;
    }
    p11944.autoClear = v9347;
  }
}